import { NgModule } from '@angular/core';
import { BigTabStripComponent } from './big-tab-strip/big-tab-strip.component';
import { BigTabComponent } from './big-tab/big-tab.component';

const components = [BigTabComponent, BigTabStripComponent];

@NgModule({ imports: components, exports: components })
export class BigTabsModule {}
